module.exports = __webpack_public_path__ + "static/media/m1.7ead4c40.jpg";